// extracted by mini-css-extract-plugin
export default {"goal_container":"Goal-page_goal_container__Inbgh"};